exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userGroupUsersWrapper .b-table{min-width:1600px}.userGroupUsersWrapper .b-table td,.userGroupUsersWrapper .b-table th{font-size:.75rem}.userGroupUsersWrapper .b-table td:nth-child(9),.userGroupUsersWrapper .b-table th:nth-child(9){max-width:340px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.authorizerMavagementTagGroupSelectWrapper .multiselect__tags{height:35px;min-height:35px;padding-top:4px;margin-top:2px;border:1px solid #ced4da;font-size:13px}.authorizerMavagementTagGroupSelectWrapper .multiselect__placeholder{color:#495057}", ""]);

// exports
